import { Box, Toolbar } from '@mui/material';

import { StyledContentContainer, StyledContentContainerMemo } from '../style';
import PatientMemo from './PatientMemo';
import NursingRecords from './NursingRecords';

export const inputInformationWidth = { xs: 340, xl: 450 };

interface Props {
  coachRefA: any;
  coachRefB: any;
}

const InputInformation = ({ coachRefA, coachRefB }: Props) => {
  return (
    <Box
      flex={1.2}
      display="flex"
      flexDirection="column"
      overflow="auto"
      width={inputInformationWidth}
    >
      <StyledContentContainerMemo sx={{ marginTop: '0px' }}>
        <PatientMemo coachRef={coachRefA} />
      </StyledContentContainerMemo>
      <StyledContentContainer sx={{ marginTop: '25px' }}>
        <NursingRecords coachRef={coachRefB} />
      </StyledContentContainer>
    </Box>
  );
};

export default InputInformation;
